export {
  centsToUSD,
  format2Decimals,
  getDiscountedAmount,
  isEven,
  isLastOfArray,
  extractDecimalNumber,
} from "./number";
